module.exports = __webpack_public_path__ + "media/components/country-flag/static/kr-79d7f348e0e8e32d979dfc9a902e20eb.svg";